import React from 'react';

// The card wrapper every portal section uses.
const Section = ({ title, subtitle, children }) => (
    <section className="mb-6 bg-white rounded-xl border border-gray-100 shadow-sm p-4">
        {title && (
            <h3 className={`text-xs font-semibold text-gray-500 uppercase tracking-wider ${subtitle ? 'mb-1' : 'mb-3'}`}>
                {title}
            </h3>
        )}
        {subtitle && <p className="text-xs text-gray-400 mb-3">{subtitle}</p>}
        {children}
    </section>
);

export default Section;
